import axios, {AxiosError} from "axios";
import rateLimit from "axios-rate-limit";

export const httpAxiosApi = rateLimit(axios.create({
    // baseURL: '/',
    timeout: 15000,
    headers: {
        'X-Application': 'Capitalist Application',
        'X-Requested-With': 'XMLHttpRequest',
        'X-Agent': 'capitalist-js',
    }
}), {
    maxRequests: 10,
    perMilliseconds: 1000,
});

// httpAxiosApi.interceptors.response.use((response) => response, (error) => {
//     // whatever you want to do with the error
//     checkLoginRequiredError(error);
//     throw error;
// });
//
// const checkLoginRequiredError = (error: AxiosError) => {
//
//     const errorCodes = [401, 403, 429];
//     if (error.response && errorCodes.includes(error.response.status)) {
//         //console.log('checkLoginRequiredError', error.response.status);
//         // check if window.location.pathname starts with '/finance'
//         const isSafeToLogoutPath = window.location.pathname !== '/login';
//         if (isSafeToLogoutPath && (window.location.pathname.startsWith('/finance'))) {
//             window.location.href = '/login';
//         }
//     }
// }

export default httpAxiosApi;
